import { Col, Row, Form as BSForm } from 'react-bootstrap';
import { FieldArray } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';

export const InterestsForm = ({ handleChange, values }) => (
  <FieldArray name="interests">
    {({ remove, push }) => (
      <>
        {values.interests &&
          values.interests.length > 0 &&
          values.interests.map((interest, index) => (
            <Row className="mb-2" key={index}>
              <BSForm.Group as={Col} controlId={`interests.${index}`}>
                <BSForm.Label>{`Interest ${index + 1}`}</BSForm.Label>
                <BSForm.Control
                  name={`interests.${index}`}
                  type="text"
                  value={interest}
                  onChange={handleChange}
                  placeholder="Type your interests here"
                />
              </BSForm.Group>

              <BSForm.Group as={Col} controlId="removeCol" className="d-flex justify-content-center align-items-center">
                <LinkButton onClick={() => remove(index)} icon={faMinusCircle}></LinkButton>
              </BSForm.Group>
              <BSForm.Group as={Col} controlId="blank" className=""></BSForm.Group>
            </Row>
          ))}

        <Row className="mb-3">
          <Col>
            <LinkButton label="Add Interest" onClick={() => push('')}></LinkButton>
          </Col>
        </Row>
      </>
    )}
  </FieldArray>
);
